export default {
	apikey: {
		test: 'pk_test_NsqtNoNyqHELJG353ASsLxVr',
		live: 'pk_live_DU1bBRoYyL2BkuiUlr6xqgiS',
	}
}


// WEBPACK FOOTER //
// ./src/Containers/Purchase/DATA_STRIPE.js